export const TERMS_CONDITIONS_URL =
  'https://www.mybrightlink.org/terms-of-use/app';
export const PRIVACY_POLICY_URL =
  'https://www.mybrightlink.org/privacy-policy/app';
